<template>
    <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button  default-href="#" @click="navigatePreviousPage"></ion-back-button>
        </ion-buttons>

        <ion-title>Manage Users to a branch / Add </ion-title>

        <!-- <ion-buttons slot="end">
          <ion-button @click="associateUserToBranch"  v-if="!viewmode">
            <ion-icon slot="start" name="add"></ion-icon>Associate User To Branch
          </ion-button>
        </ion-buttons> -->
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <AssociateUsersToBranch />
      <!-- <AssociateUsersToBranch v-if="viewmode"/> -->
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
// @ is an alias to /src
import AssociateUsersToBranch from "@/components/corporate/associateUserToBranch.vue";

import { AppUtils } from "@/util/app-utils"
import { IonBackButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar } from "@ionic/vue";

export default defineComponent ({
  name: 'associateUserToBranch',
  components: {
    AssociateUsersToBranch, IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent
  },
  data() {
    return {
      rightToAdd: false,
      viewmode: false,
      manageUser: false,
      branchId: "New",
      details: "List"
    }
  },
  mounted() {
    this.rightToAdd = new AppUtils().getUserAccess("100|L");
  },
  methods: {
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    associateUserToBranch() {
      this.$router.push({
        name: "associateUserToBranch",
        params: {branchId: this.$route.params.brnahcId}
      });
    },
    backNavigation() {
      this.$router.go(0);
    }
  }
})
</script>